import LaunchAppUI from '../index';
import getDomTree from './dom-tree';
import { trackEvent } from '../../utils/common';
const showUserGuidView = function () {
    const viewInstance = new LaunchAppUI();
    const vDom = getDomTree(viewInstance);
    viewInstance.createUI(vDom, document.body);
    trackEvent('launch_app_user_guide_popup_expose');
};
export default showUserGuidView;
